// extracted by mini-css-extract-plugin
export var alertIcon = "_rf-0";